export default {
  name: 'populateSelect',
  methods: {
    populateSelect(currentselect, newselect) {
      const items = currentselect;
      const selectizeObject = document.querySelectorAll(newselect)[0].selectize;

      items.forEach((item) => {
        selectizeObject.addOption(
          { value: item.key, text: item.num },
        );
        selectizeObject.addItem(item.key);
      });

      selectizeObject.setValue(items[0].key);
    },
  },
};
